import React from 'react';
import './BrandsSection.css';

function BrandsSection() {
  return (
    <section className="brands-section">
      <h2 className="brands-title">
        {'Trusted by brands'.split('').map((char, index) => (
          <span key={index} className={`letter letter-${index}`}>
            {char === ' ' ? '\u00A0' : char}
          </span>
        ))}
      </h2>
      <div className="brands-logos">
        <img className="brand-logo" src="/images/01 Sunshine Bakery.svg" alt="Brand 1" />
        <img className="brand-logo" src="/images/02 Durex.svg" alt="Brand 2" />
        <img className="brand-logo" src="/images/03 Pizza Hut.svg" alt="Brand 3" />
        <img className="brand-logo" src="/images/04 Taco Bell.svg" alt="Brand 4" />
        <img className="brand-logo" src="/images/05 AnW.svg" alt="Brand 5" />
        <img className="brand-logo" src="/images/01 IMM.svg" alt="Brand 6" />
        <img className="brand-logo" src="/images/02 Great World.svg" alt="Brand 7" />
        <img className="brand-logo" src="/images/03 Velocity.svg" alt="Brand 8" />
        <img className="brand-logo" src="/images/04 United Square Learning Mall.svg" alt="Brand 9" />
        <img className="brand-logo" src="/images/05 Marina Square.svg" alt="Brand 10" />
      </div>
    </section>
  );
}

export default BrandsSection;
